import styled from "styled-components";
import colors from "@streeteasy/design-system/deprecated/colors";

export const Error = styled.div`
  background: rgba(237, 67, 47, 0.12);
  border-color: ${colors.errorRed};
  color: ${colors.errorRed};
  height: 44px;
  line-height: 14px;
  margin-top: 16px;
  padding: 15px;
  position: relative;
`;
